<ion-header [translucent]="!modalCtrl">
    <ion-toolbar>
        <ion-title>{{'pages.info.btn-privacy' | translate}}</ion-title>
        <ion-buttons *ngIf="modalCtrl" slot="end">
            <ion-button (click)="modalCtrl.dismiss()">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="language === 'de'; else contentEn" class="ion-padding">
    <h1 *ngIf="!modalCtrl">Datenschutzbestimmungen</h1>
    <p>
        Die EFTAS GmbH, nachfolgend kurz EFTAS genannt, nimmt den Schutz Ihrer personenbezogenen Daten sehr ernst. Diese
        Datenschutzerklärung ergänzt unsere Allgemeine Nutzungs- und Teilnahmebedingungen. Die nachfolgende Erklärung
        informiert Sie darüber, welche personenbezogenen Daten erhoben werden und wie diese verarbeitet und genutzt werden,
        wenn sie den Service des EFTAS CropAnalyzer (im nachfolgenden kurz CropAnalyzer genannt) nutzen. Der CropAnalyzer
        ist ein Service der EFTAS auf der Webseite www.crop-analyzer.eftas.com, sowie den zugehörigen mobilen Apps und auf
        zugehörigen Seiten, Integrationslösungen, Tools, API oder anderen Diensten wie in unseren Allgemeine Nutzungs- und
        Teilnahmebedingungen beschrieben.
    </p>
    <p>
        Verantwortliche Stelle für die Datenverarbeitung im Rahmen dieser App ist die EFTAS GmbH, Oststraße 2, 48145
        Münster in Westfalen (im Folgenden auch kurz EFTAS genannt).
    </p>

    <h2>Datenschutz Webseite</h2>
    <p>
        Die Nutzung des CropAnalyzer ist ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten
        personenbezogene Daten (Email-Adresse) erhoben werden, erfolgt dies, soweit
        möglich, stets auf freiwilliger Basis. Bei der Nutzung von Kartendaten und Standort-basierten Funktionen findet
        keine personenbezogene Zuordnung statt.
    </p>
    <p>
        Durch eine optinonale Angabe der E-Mail-Adresse, kann ein Benachrichtigungsdienst bei Verarbeitung mehrerer Fotos genutzt
        werden. Außerdem kann die E-Mail-Adresse zur Wiederherstellung des Benutzerkontos genutzt werden.
    </p>
    <p>
        Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. Es wird darauf hingewiesen,
        dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
        lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. Der Nutzung von im Rahmen der
        Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter
        Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich
        ausdrücklich rechtliche Schritte vor im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch
        Spam-Mails.
    </p>

    <h2>Datenschutz mobile Applikation</h2>
    <p>
        Die Nutzung der CropAnalyzer App ist in der Regel ohne Angabe personenbezogener Daten möglich. Ihre Klassifikationsaufträge werden
        einem anonymisierten Benutzerkonto zugewiesen. Das verhindert, dass andere Benutzer Zugriff auf Ihre Daten haben. 
        Sie können Ihre Nutzer-ID speichern, um die Löschung der Daten anzufordern. Diese Daten werden ohne Ihre ausdrückliche Zustimmung
        nicht an Dritte weitergegeben.
    </p>
    <p>
        Über das Foto Upload Formular ist es Nutzern möglich Fotos an den CropAnalyzer zu übermitteln. Mit dem Hochladen und
        Übermitteln dieser Daten und Fotos räumt der App Nutzer der EFTAS ein zeitlich unbefristetes und unentgeltliches
        Nutzungsrecht an diesen Daten und Fotos ein. Dieses Recht schließt auch das Recht auf Veränderung und
        Veröffentlichung dieser Daten ein.
    </p>
    <p>
        Mit der Nutzung des CropAnalyzer willigt der Teilnehmer in die Erhebung und Speicherung sowie
        gegebenenfalls Verarbeitung der zuvor genannten Daten ein. Widerruft ein Benutzer diese Einwilligung, werden
        sämtliche personenbezogenen Daten des Benutzers gelöscht. Damit endet auch das Nutzungsverhältnis.
    </p>
    <p>
        Die EFTAS ist berechtigt, jederzeit und ohne Angabe von Gründen Nutzer von dem Zugang zu ihren Webseiten
        auszuschließen und diesen auf Dauer von der weiteren Nutzung zu sperren. Dies gilt insbesondere bei wiederholtem
        Verstoß gegen die vorgenannten Nutzungsbedingungen und zum Schutz der übrigen Nutzer.
    </p>
    <p>
        Zur Bereitstellung unserer Dienste über die App, benötigen wir die im Folgenden aufgezählten Zugriffsrechte, die es
        uns ermöglichen, auf bestimmte Funktionen Ihres Geräts zuzugreifen:
    </p>
    <ul>
        <li>Standort: Die App greift auf Ihren genauen GPS-Standort zu. Die GPS Daten werden für die Verortung des
            Aufnahme-Fotos benötigt.
        </li>
        <li>Fotos/Medien/Dateien: Die App benötigt Zugriffsrechte um SD-Karten-Inhalte ändern oder löschen zu können.
            Dieses Recht wird für das Herunterladen von App - Fotos sowie zum Hochladen von Fotos benötigt.
        </li>
        <li>Kamera: Über das Zugriffsrecht auf die Kamera Ihres Gerätes, wird Ihnen ermöglicht ein neues Bild
            aufzunehmen und zu übermitteln. Bei den aufgenommenen Bildern werden die Meta-Daten (EXIF) der Bilder
            entsprechend Endgerät (Aufnahmekoordinaten, Aufnahmezeit, Aufnahmeparameter, Art des Endgeräts) erfasst
        </li>
        <li>WLAN: Die WLAN-Verbindung wird benötigt, um App Inhalte abzurufen und Bilder-Uploads durchzuführen.</li>
        <li>Internet Zugriff: Eine Internet Verbindung wird benötigt, um App Inhalte vom Server abzurufen und ggf. Daten
            zu synchronisieren.
        </li>
    </ul>

    <h2>Kontakt- und Feedbackformular</h2>
    <p>
        Wenn Sie uns per Kontaktformular Feedback zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der
        von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns
        gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
    </p>

    <h2>Bildinformationen</h2>
    <p>
        Zum Zwecke des Datenschutzes muss ausgeschlossen sein, dass erkennbare Personen, Kennzeichen oder Schilder mit
        persönlicher Registrierung, die eine Identifizierung des Ortes oder der Person ermöglichen, auf den Fotos enthalten
        sind. Daher sind Fotos mit erkennbaren Gesichtszügen oder Kennzeichen mit erkennbaren Schriftzeichen nicht
        gestattet. Da eine vollständige Kontrolle nicht zumutbar ist, werden Bilder stichprobenartig und teilweise
        automatisiert kontrolliert und aus dem System gelöscht. Bei vereinzelt auftretenden Fotos, die dennoch
        Erkennungs-Elemente enthalten, die eine Anonymisierung bedingen, wird die EFTAS diese nach Meldung umgehend und
        ersatzlos aus dem System löschen.
    </p>

    <h2>Nutzungsdaten</h2>
    <p>
        Der CropAnalyzer benutzt <a href="https://matomo.org" target="_blank">Matomo</a>, eine Open-Source-Software zur statistischen Auswertung der
        Besucherzugriffe. Matomo verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die
        eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre
        Benutzung dieses Internetangebotes werden auf einem Server des Anbieters gespeichert. Die IP-Adresse wird sofort
        nach der Verarbeitung und vor deren Speicherung anonymisiert. Die erhobenen Daten sind nicht personenbezogen; wir
        können also nicht nachvollziehen, welcher Nutzer welche Daten abgerufen hat. Im Einzelnen besteht jeder Datensatz
        aus:
    </p>
    <ul>
        <li>der Seite, von der aus die Datei angefordert wurde</li>
        <li>dem Namen der abgerufenen Datei</li>
        <li>dem Datum und Uhrzeit der Anforderung</li>
        <li>der übertragene Datenmenge</li>
        <li>dem Zugriffsstatus (Datei übertragen, Datei nicht gefunden etc.)</li>
        <li>einer Beschreibung des Typs des verwendeten Webbrowsers</li>
        <li>IP-Adresse (anonymisiert)</li>
    </ul>
    <p>
        Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir
        weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website
        vollumfänglich nutzen können.
    </p>

    <h2>Recht auf Auskunft, Löschung, Sperrung</h2>
    <p>
        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren
        Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung
        dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der
        im Impressum angegebenen Adresse an uns wenden. 
    </p>

    <h2>Änderung dieser Datenschutzbestimmungen</h2>
    <p>
        Die EFTAS behält sich das Recht vor, diese Datenschutz-Bestimmungen und Hinweise, unter Einhaltung der gesetzlichen
        Bestimmungen, jederzeit zu ändern. Solche Änderungen treten zwei Wochen nach ihrer Veröffentlichung auf der Webseite
        in Kraft.
    </p>
</ion-content>

<ng-template #contentEn>
    <ion-content class="ion-padding">
        <h1 *ngIf="!modalCtrl">Privacy Policy</h1>
        <p>
            EFTAS GmbH, hereinafter referred to as EFTAS, takes the protection of your personal data very seriously. This
            Privacy Policy supplements our General Terms and Conditions of Use. The following declaration
            informs you about which personal data is collected and how it is processed and used,
            when you use the service of the EFTAS CropAnalyzer (hereinafter referred to as CropAnalyzer). The CropAnalyzer
            is a service provided by EFTAS on the website www.crop-analyzer.eftas.com, as well as the associated mobile apps and on
            related pages, integration solutions, tools, API or other services as described in our General Terms and  Conditions of Use.
        </p>
        <p>
            The responsible party for data processing within the scope of this app is EFTAS GmbH, Oststraße 2, 48145
            Münster in Westphalia (hereinafter also referred to as EFTAS).
        </p>

        <h2>Privacy Policy Web Site</h2>
        <p>
            The use of the CropAnalyzer is possible without providing personal data. If
            personal data (e-mail address) is collected on our website, this is done, as far as possible, on a voluntary basis.
            When using map data and location-based functions, no personal geolocation tracking takes place.
        </p>
        <p>
            By specifying the e-mail address, a notification service can be used when processing multiple photos.
            Also, the email address can be used to restore the user account.
        </p>
        <p>
            This data will not be disclosed to third parties without your expressed consent. Data transmission on the Internet (e.g. communication by e-mail) can have security gaps. A
            complete protection of data against access by third parties is not possible. The use of
            contact data published via the imprint obligation  by third parties is hereby expressly prohibited. The operators of the pages reserve the right to take
            legal steps in the case of unsolicited promotional information, such as spam by e-mail.
        </p>

        <h2>Privacy Policy Mobile Application</h2>
        <p>
            The use of the CropAnalyzer is possible without providing personal data. If
            personal data (e-mail address) is collected on our website, this is done, as far as possible, on a voluntary basis. Your classification orders are
            assigned to an anonymous user account. This prevents other users from accessing your data. 
            You can save your user ID to request the deletion of your data.
            When using map data and location-based functions, no personal geolocation tracking takes place. 
            This data will not be disclosed to third parties without your expressed consent.
        </p>
        <p>
            The image upload form allows users to submit photos to the CropAnalyzer. With the data and photo upload , the app user grants EFTAS the right to use these data and photos for other purposes. This right also includes the right to modify and
            publish this data.
        </p>
        <p>
            By using the CropAnalyzer, the participant consents to the collection and storage as well as the
            processing of the aforementioned data, if applicable. If a user revokes this consent, all personal data of the
            all personal data of the user will be deleted. This also ends the user relationship.
            The image upload form allows users to submit photos to the CropAnalyzer. With the data and photo upload , the app user grants EFTAS the right to use these data and photos for other purposes. This right also includes the right to modify and
        </p>
        <p>
            EFTAS is entitled at any time and without giving reasons to exclude users from accessing its websites and to block them permanently from further use. This shall apply in particular in the event of repeated
            violation of the aforementioned terms of use and for the protection of the other users.
        </p>
        <p>
            In order to provide our services through the CropAnalyzer App, we require the device access rights enumerated below:
        </p>
        <ul>
            <li>Location: The app accesses your exact GPS location. The GPS data is required for the location of the
                captured photo.
            </li>
            <li>Photos/Media/Files: The app needs access rights to be able to change or delete SD card contents.
                This right is required for downloading app photos as well as uploading photos.
            </li>
            <li>Camera: The access right to the camera of your device allows you to take and send a new picture.
                For the captured photos the meta data (EXIF) of the images will be recorded
                according to the end device (coordinates, time, shooting parameters, type of end device)
            </li>
            <li>WLAN: The WLAN connection is required to retrieve app content and perform image uploads.</li>
            <li>Internet access: An Internet connection is required to retrieve app content from the server and to synchronize data.
            </li>
        </ul>

        <h2>Contact and feedback form</h2>
        <p>
            If you send us feedback via the contact form, your details from the inquiry form, including the contact details you have
            provided will be stored by us for the purpose of processing the request and in case of follow-up questions.
            We do not pass on this data without your consent.
        </p>

        <h2>Photo content</h2>
        <p>
            For the purpose of data protection, it must be excluded that recognizable persons, license plates or signs with
            registration, which would allow identification of the place or person, are included in the photos.
            Therefore, photos with recognizable facial features or license plates with recognizable characters are not allowed.
            Since a complete control is not feasible, pictures will be controlled randomly and maybe
            deleted from the system. In the case of sporadic photos that nevertheless contain
            elements that require anonymization, EFTAS will delete them from the system immediately after being notified.
        </p>

        <h2>Usage data</h2>
        <p>
            The CropAnalyzer uses Matomo, an open-source software for the statistical analysis of
            visitor accesses. Matomo uses "cookies", which are text files placed on your computer, to help the website analyze how users use the site.
            The information generated by the cookie about your
            website use is stored on a server of the provider. The IP address is immediately
            anonymized after processing and before it is stored. The data collected is not personal; we therefore
            cannot trace which user has accessed which data. In detail, each data record consists of:
        </p>
        <ul>
            <li>the page from which the file was requested</li>
            <li>the name of the requested file</li>
            <li>the date and time of the request</li>
            <li>the amount of data transferred</li>
            <li>the access status (file transferred, file not found, etc.)</li>
            <li>a description of the type of web browser used</li>
            <li>IP-adress (anonymized)</li>
        </ul>
        <p>
            You may refuse the use of cookies by selecting the appropriate settings on your browser, however please note that if you do this you may not be able to use the full functionality of this website.
        </p>

        <h2>Right to information, deletion, blocking</h2>
        <p>
            You have the right at any time to receive free information about your stored personal data, their
            origin and recipient and the purpose of data processing as well as the right to correct, block or delete
            this data. For this as well as for further questions on the subject of personal data, you can contact us at any time under the
            address given in the imprint. 
        </p>

        <h2>Amendment of this privacy policy</h2>
        <p>
            EFTAS reserves the right to change these data protection conditions and notices at any time, in compliance with the legal provisions.
            Such changes will come into force two weeks after their publication on the website.
        </p>
    </ion-content>
</ng-template>

<ion-footer *ngIf="modalCtrl">
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-button (click)="modalCtrl.dismiss()" color="secondary">{{'shared.btn-close' | translate}}</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>